const Button = ({ startSlot, endSlot, label, className, ...props }) => {
  return (
    <button
      className={["flex justify-between items-center gap-2", className].join(
        " "
      )}
      {...props}
    >
      <span>{startSlot}</span>
      <span>{label}</span>
      <span>{endSlot}</span>
    </button>
  );
};

export default Button;
